import { render, staticRenderFns } from "./weightCard.vue?vue&type=template&id=c827acc0&scoped=true&"
import script from "./weightCard.vue?vue&type=script&lang=js&"
export * from "./weightCard.vue?vue&type=script&lang=js&"
import style0 from "./weightCard.vue?vue&type=style&index=0&id=c827acc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c827acc0",
  null
  
)

export default component.exports